import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import { FavoritesProvider } from "./Component/FavoritesContext";
import { ToastProvider } from "./Component/ToastContext";
import PaySuccess from "./Component/SuccessPay";
import PayFail from "./Component/PayFail";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import SubscriptionPage from "./Component/Subscribe";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Delivery from "./Component/Delivery";
import Login from "./Component/Login";
import Register from "./Component/Register";
import Profile from "./Component/Profile";
import Orders from "./Component/Orders";
import OrderDetail from "./Component/OrderDetail";
import Tracking from "./Component/Tracking";
import Aftersales from "./Component/Aftersales";
import Favorites from "./Component/Favorites";
import Coupons from "./Component/Coupons";
import Blog from "./Component/Blog";
import TrackingOrder from "./Component/TrackingOrder";
import "./css/toast.scss";

function App() {
  return (
    <ToastProvider>
      <CartProvider>
        <FavoritesProvider>
          <Router>
            <Routes>
              <Route path="/about" element={<About />} />
              <Route path="/shipping" element={<Delivery />} />
              <Route path="/" element={<Main />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/subscribe" element={<SubscriptionPage />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/shopDetails/:id" element={<ProductDetail />} />
              <Route path="/cartpage" element={<CartPage />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/paysuccess" element={<PaySuccess />} />
              <Route path="/payfail" element={<PayFail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/orderDetail/:orderId" element={<OrderDetail />} />
              <Route path="/tracking/:orderId" element={<Tracking />} />
              <Route path="/tracking-order" element={<TrackingOrder />} />
              <Route path="/aftersales/:orderId/:type?" element={<Aftersales />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/coupons" element={<Coupons />} />
              <Route path="/blog" element={<Blog />} />
            </Routes>
          </Router>
        </FavoritesProvider>
      </CartProvider>
    </ToastProvider>
  );
}

export default App;
